import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import Seo from '../components/Seo';
import ImageWithFallback from '../components/ImageWithFallback';
import { writingsApi, WRITING_TYPE_LABELS } from '../services/api';

const WritingDetailPage = () => {
  const { id } = useParams();
  const [writing, setWriting] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    writingsApi.getById(id).then((data) => setWriting(data.writing)).catch((err) => setError(err.message));
  }, [id]);

  return (
    <Layout>
      <Seo title={writing?.title || 'كتابة'} description={writing?.content?.slice(0, 150)} />
      <div className="container-responsive max-w-3xl py-14">
        {error && <p className="text-error-600">{error}</p>}
        {writing && (
          <article className="overflow-hidden rounded-[2rem] bg-white shadow-large dark:bg-stone-900">
            <div className="h-64">
              <ImageWithFallback src={writing.cover_url || writing.martyr_image_url || '/default.png'} alt={writing.title} className="h-full w-full object-cover" />
            </div>
            <div className="space-y-4 p-8 md:p-12">
              <span className="text-sm text-gold-700">{WRITING_TYPE_LABELS[writing.writing_type]}</span>
              <h1 className="text-4xl font-bold">{writing.title}</h1>
              <p className="text-stone-500">الكاتب: {writing.author}</p>
              {writing.martyr_id ? (
                <p>عن الشهيد <Link className="text-primary-800 underline" to={`/martyr/${writing.martyr_id}`}>{writing.martyr_name_ar}</Link></p>
              ) : (
                <p className="text-stone-500">كتابة عامة</p>
              )}
              {writing.content && <div className="whitespace-pre-line text-lg leading-loose">{writing.content}</div>}
              {writing.file_url && <a className="btn btn-primary" href={writing.file_url} target="_blank" rel="noreferrer">تحميل الملف</a>}
              <Link to={writing.martyr_id ? `/writings?id=${writing.martyr_id}` : '/writings'} className="btn btn-outline">العودة للكتابات</Link>
            </div>
          </article>
        )}
      </div>
    </Layout>
  );
};

export default WritingDetailPage;
